import { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { loadScriptPromise } from "../../../common/utils/script.ts";
import { useBrandLoaderData } from "../../root/rootLoader.ts";
import { isNative } from "common/utils/native.ts";

export default function Zenchat() {
  const intl = useIntl();
  const brand = useBrandLoaderData();
  const isNativeApp = isNative();

  const initPromise = useMemo(
    () =>
      brand.Support.Zenchat.enabled && !isNativeApp
        ? loadScriptPromise("/zenchat/script.js").catch(() => {})
        : Promise.resolve(),
    [brand, isNativeApp]
  );

  useEffect(() => {
    void initPromise.then(() => window.Zenchat?.setLocale(intl.locale));
  }, [initPromise, intl.locale]);

  useEffect(() => {
    void initPromise.then(() => {
      const zIndex = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          "--zenchat-overlay-z"
        ),
        10
      );
      void window.Zenchat?.setZIndex(zIndex);
    });
  }, [initPromise]);

  return null;
}
